<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" [routerLink]="['/']"></i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">
            
            <span> مدیریت مسیر  </span>
            
        </a>

    </div>

</div>

<!--  -->

<div class="d-flex container justify-content-around flex-wrap dirI col-md-5 col-12 mx-auto">

    <div class="w-50 my-1 px-1 text-center " (click)="bStation = true">

        <p [ngClass]="bStation ? 'bg-success' : 'bg-secondary' " class="border border-2 rounded text-white pointer my-1 p-2"> ایستگاه ها </p>

    </div>

    <div class="w-50 my-1 px-1 text-center " (click)="bStation = false">

        <p [ngClass]="!bStation ? 'bg-success' : 'bg-secondary' " class="border border-2 rounded bg-secondary text-white pointer my-1 p-2"> مسیر ها </p>

    </div>
    
</div>

<!--  -->

<section class="container d-flex flex-column  align-items-start pt-3 dirI">

    <div class="col-12 col-md-10 d-flex flex-wrap justify-content-between align-items-end mb-2">

        <div class="col-12 col-md-10">

            <input class="form-control" placeholder="جستجو کنید..." (keyup)="bStation ? filterStation($event.target) : filterRoute($event.target) ">

        </div>

        <ng-container *ngIf="bStation">

            <div class="col-12 col-md-2 px-2">

                <button class="w-100 btn btn-primary" data-bs-toggle="modal" data-bs-target="#Add-station-modal" (click)="newOpenMap()"> ایستگاه جدید </button>
    
            </div>
    
        </ng-container>

        <ng-container *ngIf="!bStation">

            <div class="col-12 col-md-2 px-2">

                <button class="w-100 btn btn-primary" data-bs-toggle="modal" data-bs-target="#Add-Route-modal" (click)="reset_Route_Value()"> مسیر جدید </button>
    
            </div>
    
        </ng-container>

    </div>

    <ng-container *ngIf="bStation">

        <table class="col-12 table table-striped border border-2 rounded-3 ">

            <thead>

                <tr class="">

                    <th class="text-center"> ردیف </th>

                    <th class="text-center"> عملیات </th>

                    <th class="text-center pointer"> کد ایستگاه </th>

                    <th class="text-center pointer"> نام ایستگاه </th>

                    <th class="text-center pointer"> توضیحات </th>

                </tr>
                
            </thead>

            <tbody>

                <tr *ngFor="let item of list_Station; let i=index">

                    <td class="text-center">{{ i + 1 | faNum }}</td>

                    <td class="dirl f22 text-center pointer">

                        <i class="fa fa-edit text-primary mx-1" title="ویرایش" (click)="editStation_Modal(item)" data-bs-toggle="modal" data-bs-target="#Add-station-modal"></i>

                        <i class="fa fa-trash text-danger mx-1" title="حذف" (click)="deleteStation(item)"></i>

                    </td>

                    <td class="text-center"> {{ item.strCode | faNum }} </td>

                    <td class="text-center"> {{ item.strName | faNum }} </td>

                    <td class="text-center"> {{ item.strComment | faNum }} </td>

                </tr>

            </tbody>
            
        </table>
    
    </ng-container>

    <ng-container *ngIf="!bStation">

        <table class="col-12 table table-striped border border-2 rounded-3 ">

            <thead>

                <tr class="">

                    <th class="text-center col-1"> ردیف </th>

                    <th class="text-center"> عملیات </th>

                    <th class="text-center pointer"> کد مسیر </th>

                    <th class="text-center pointer"> نام مسیر </th>

                    <th class="text-center pointer"> طول </th>

                    <th class="text-center pointer"> رنگ </th>

                </tr>
                
            </thead>

            <tbody>

                <tr *ngFor="let item of list_Route; let i=index">

                    <td class="col-1 text-center"> {{ i + 1 | faNum }} </td>

                    <td class="dirl f22 text-center pointer">

                        <i class="fa fa-edit text-primary mx-1" title=" ویرایش" (click)="editRoute_Modal(item)" data-bs-toggle="modal" data-bs-target="#Add-Route-modal"></i>

                        <i class="fa fa-trash text-danger mx-1" title=" حذف " (click)="deleteRoute(item)"></i>
                        
                        <i class="fa fa-map-signs text-success mx-1" title=" ایستگاه ها " (click)="get_Route_Station(item)"></i>

                        <i class="fa fa-user-circle text-secondary mx-1" title=" کاربر مسیر " (click)="get_Route_Users(item)"></i>

                        <i title="تعرفه مسیر" (click)="get_Route_Costs(item)">

                            <img width="24px" src="../../../assets/Img/budget.png" alt="">
                        
                        </i>

                    </td>

                    <td class="text-center"> {{ item.strCode | faNum }} </td>

                    <td class="text-center"> {{ item.strName | faNum }} </td>

                    <td class="text-center"> {{ item.iLength.toLocaleString() | faNum }} </td>

                    <td class="text-center">
                        
                        <div style="height:20px; width:100%;border-radius:10px;" 
                        
                            [ngStyle]="{'background-color' : item?.strColor ? item.strColor : 'blue' }">
                        
                        </div>
                    
                    </td>

                </tr>

            </tbody>
            
        </table>
    
    </ng-container>

</section>

<!--  -->

<div class="modal fade" id="Add-station-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{editMode ? ' ویرایش ایستگاه ' : ' ثبت ایستگاه جدید ' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body dirI">

                <div class="d-flex flex-wrap justify-content-between" [formGroup]="saveStationForm">

                    <div class="col-12 col-md-6 ps-1">

                        <label class="mb-2 dirI w-100 text-start"> نام ایستگاه </label>

                        <input class="form-control dirI" formControlName="strName" maxlength="40">

                    </div>

                    <div class="col-12 col-md-6 pe-1">

                        <label class="mb-2  w-100 text-start"> کد ایستگاه </label>

                        <input class="form-control text-end" formControlName="strCode" maxlength="10">

                    </div>

                    <div class="col-12 mt-4">

                        <textarea style="height: 100px; max-height: 100px;" placeholder="توضیحات" class="form-control dirI" formControlName="strComment" maxlength="300"> </textarea>

                    </div>

                </div>

            </div>

            <hr class="mb-0">

            <div id="test" class="position-sticky w-100" style="height: 300px;">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

            <div class="modal-footer dirI d-flex justify-content-between">

                <button class="btn btn-warning w-fit" (click)="changeTail()">

                    تغییر نوع نقشه
                    
                    <i class="fa fa-map-marker"></i>
                
                </button>

                <button type="button" class="btn btn-primary px-4" (click)="editMode ? editStation() : newStation()">
                    
                    {{ editMode ? ' ویرایش ' : ' ثبت ' }}
                    
                </button>

            </div>

        </div>

    </div>

</div>

<!--  -->

<div class="modal fade" id="Add-Route-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{editMode ? ' ویرایش مسیر ' : ' ثبت مسیر جدید ' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body dirI">

                <div class="d-flex flex-wrap justify-content-between" [formGroup]="saveRouteForm">

                    <div class="col-12 col-md-6 ps-1">

                        <label class="mb-2 dirI w-100 text-start"> نام مسیر </label>

                        <input class="form-control  dirI " maxlength="40" formControlName="strName">

                    </div>

                    <div class="col-12 col-md-6 pe-1">

                        <label class="mb-2  w-100 text-start" maxlength="10"> کد مسیر </label>

                        <input class="form-control dirl text-end " formControlName="strCode">

                    </div>

                    <div class="col-12 col-md-6 pe-1 mt-2">

                        <label class="mb-2 dirl w-100 text-start"> طول </label>

                        <input class="form-control dirI" formControlName="iLength">

                    </div>

                    <div class="col-12 col-md-6 pe-1 mt-2">

                        <!-- [ngStyle]="{'background-color' : saveRouteForm.get('strColor')?.value }" -->

                        <label class="mb-2 dirI w-100 text-start"> کد رنگ </label>

                        <input type="color" style="height: 38px!important;" name="favcolor" class="w-100" formControlName="strColor">

                    </div>

                    <div class="col-12 mt-4">

                        <textarea style="height: 120px; max-height: 120px;" placeholder="توضیحات" class="form-control dirI" formControlName="strComment" maxlength="300"> </textarea>

                    </div>

                </div>

            </div>

            <div class="modal-footer dirI">

                <button type="button" class="btn btn-primary px-4" (click)="editMode ? editRoute() : newRoute()">
                    
                    {{ editMode ? ' ویرایش ' : ' ثبت ' }}
                    
                </button>

            </div>

        </div>

    </div>

</div>

<!-- ایستگاه های مسیر -->

<div class="modal fade" id="Add-Route-Station-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{ editMode ? 'ویرایش' : bRoute_Station && !editMode ? ' ثبت ایستگاه جدید ' : ' ایستگاه های مسیر ' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body dirI">

                <div class="d-flex flex-column align-items-start dirI">

                    <ng-container *ngIf="!bRoute_Station">

                        <div class="col-12 d-flex flex-wrap justify-content-between align-items-end mb-2">

                            <div class="col-12 col-md-10">
    
                                <input class="form-control" placeholder="جستجو کنید...">
    
                            </div>
    
                            <div class="col-12 col-md-2 px-2">
    
                                <button class="w-100 btn btn-primary" (click)="show_RouteStation_Form()"> ایستگاه جدید </button>
                    
                            </div>
    
                            <table class="col-12 table table-striped border border-2 rounded-3 mt-3">
    
                                <thead>
    
                                    <tr class="col-12">
                                    
                                        <th class="text-center col-1"> عملیات </th>
    
                                        <th class="text-center col-1"> ردیف </th>
                    
                                        <th class="text-center col-1"> کد ایستگاه </th>

                                        <th class="text-center col-1"> نوع ایستگاه </th>

                                        <th class="text-center col-1"> نام </th>
                    
                                        <th class="text-center col-1"> توضیحات </th>
                    
                                    </tr>
                                    
                                </thead>
    
                                <tbody>
    
                                    <tr class="text-center" *ngFor="let item of list_Route_Station; let i=index">
    
                                        <td class="dirl f22 text-center pointer">
    
                                            <i class="fa fa-edit text-primary mx-1" title=" ویرایش" (click)="show_RouteStation_Form_Edit(item)"></i>
                    
                                            <i class="fa fa-trash text-danger mx-1" title=" حذف " (click)="delete_Route_Station(item)"></i>
                                            
                                        </td>
    
                                        <td> {{ item.iIndex | faNum }} </td>
    
                                        <td> {{ item.strRoute_Station_strCode | faNum }} </td>
                                        
                                        <td> {{ item.strType | faNum }} </td>

                                        <td> {{ item.strRoute_Station_strName | faNum }} </td>
    
                                        <td> {{ item.strComment | faNum }} </td>
    
                                    </tr>
    
                                </tbody>
    
                            </table>
    
                        </div>

                    </ng-container>

                    <ng-container *ngIf="bRoute_Station">

                        <div [formGroup]="saveRoute_Station_Form" class="row w-100 gx-3 px-2 gy-2 gy-md-0">

                            <div class="col-12 col-md-6">

                                <label class="mb-2"> ایستگاه </label>
                    
                                <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    
                                <input type="text"  [placeholder]="list_Station.length == 0 && search_Station == '' ? ' لطفا اندکی صبر کنید ' : 'جستجو کنید'  "
                                
                                name="selectedCarName" autocomplete="off" class="form-control" 
                    
                                (focus)="filtered_Station = list_Station"
                                
                                [(ngModel)]="search_Station" [ngModelOptions]="{standalone: true}" (input)="filter_Station_()" />
                    
                                <ul class="list-group" style="max-height: 200px;overflow: auto;">
                    
                                    <li class="list-group-item pointer" *ngFor="let item of filtered_Station" [@fadeAnimation] (click)="selected_Station(item)"> {{ item.strName }}</li>
                    
                                </ul>
                    
                            </div>
    
                            <div class="col-12 col-md-6 dirI">
    
                                <label class="mb-2"> نوع ایستگاه </label>
    
                                <select formControlName="tiType" class="form-select">
    
                                    <option [value]="-1"> انتخاب کنید </option>
    
                                    <option [value]="0"> ایستگاه مبدا </option>
    
                                    <option [value]="1"> ایستگاه مقصد </option>
    
                                    <option [value]="2"> ایستگاه میانی </option>
    
                                    <option [value]="3"> ایستگاه مجازی </option>
    
                                </select>
    
                            </div>

                            <div class="col-12 col-md-6">

                                <label class="mb-2"> حداقل زمان حضور در ایستگاه(ثانیه) </label>
    
                                <input dir="ltr" class="form-control" formControlName="iMinPresence">
    
                            </div>

                            <div class="col-12 col-md-6">

                                <label class="mb-2"> ردیف </label>
    
                                <input dir="ltr" class="form-control" formControlName="iIndex">
    
                            </div>

                            <div class="col-12 mt-4">

                                <textarea formControlName="strComment" style="height: 120px; max-height: 120px;" placeholder="توضیحات" class="form-control dirI"> </textarea>
        
                            </div>

                        </div>

                    </ng-container>

                </div>

            </div>

            <div class="modal-footer dirI">

                <ng-container *ngIf="bRoute_Station">

                    <div class="col-12 col-md-2">

                        <button class="w-100 btn" [ngClass]="editMode ? 'btn-primary' : 'btn-success' " (click)="editMode ? edit_RouteStation() : new_RouteStation()">
                            
                             {{ editMode ? 'ویرایش' : 'ذخیره' }}
                        
                        </button>
            
                    </div>

                    <div class="col-12 col-md-2 px-2">

                        <button class="w-100 btn btn-danger" (click)="bRoute_Station = false; editMode=false"> بازگشت </button>
            
                    </div>

                </ng-container>

            </div>

        </div>

    </div>

</div>

<!-- کاربر مسیر -->

<div class="modal fade" id="Route-user-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> کاربران مسیر </h5>
  
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  
        </div>
  
        <div dir="rtl" class="router-user-container p-2 py-3">

        <div class="row align-items-center gx-2 pb-2">

            <div class="col-12 col-md-8">

                <input type="text" class="form-control" (keyup)="filter_RouteUser($event.target)" placeholder="جستجو کنید ...">

            </div>

            <div class="col-6 col-md-2">

                <button class="w-100 btn btn-primary" (click)="addOrRemoveAllUser(true)"> انتخاب همه </button>

            </div>

            <div class="col-6 col-md-2">

                <button class="w-100 btn btn-danger" (click)="addOrRemoveAllUser(false)"> حذف همه </button>

            </div>

        </div>

          <div dir="rtl" class="table-responsive " style="max-height: 500px;overflow: auto;">
  
            <table class="table table-striped" *ngIf="list_Route_Users.length > 0">
  
              <thead class="position-sticky top-0 bg-white">
  
                <tr class="col-12 text-center">
  
                  <th> انتخاب </th>
  
                  <th> نام کاربر </th>
  
                  <th> حوزه خدمت </th>
  
                </tr>
  
              </thead>
  
              <tbody>
  
                <tr class="text-center col-12" *ngFor="let item of list_Route_Users">
  
                  <td><input type="checkbox" (change)="onCheckbox_User_Route($event.target.checked,item)" [checked]="item.bSelected  == 1 ? true : false "></td>
  
                  <td>{{ item.strFullName | faNum}}</td>
  
                  <td>{{ item.strMobile_strComment | faNum}}</td>
  
                </tr>
  
              </tbody>
  
            </table>
  
            <div class="text-center p-3" *ngIf="list_Route_Users.length == 0">
  
              موردی یافت نشد
  
  
            </div>
  
          </div>
  
        </div>
  
      </div>
  
    </div>
  
</div>

<!-- هزینه سرویس -->

<div class="modal fade" id="Route_Cost-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> {{ bEditMode ? 'ویرایش' : bRouteCost ? 'ثبت' : 'هزینه سرویس' }} </h5>
  
          <button *ngIf="!bRouteCost" type="button" class="btn-close"
          
                data-bs-dismiss="modal" aria-label="Close">
            
            </button>

          <button *ngIf="bRouteCost" type="button" class="btn-close" 
          
                (click)="bRouteCost=false" aria-label="Close">
            
            </button>
  
        </div>

        <div class="modal-body">

            <ng-container *ngIf="!bRouteCost">

                <div class="pb-2">

                    <button class="btn btn-success px-5" (click)="openNewRoute()"> افزودن </button>
    
                </div>
    
                <div dir="rtl" class="table-responsive" style="max-height: 500px;overflow: auto;">
      
                    <table class="table table-striped">
          
                        <thead class="position-sticky top-0 bg-white">
            
                            <tr class="col-12 text-center">
            
                                <th> # </th>
    
                                <th> عملیات </th>
                
                                <th> نوع خودرو </th>
                
                                <th> هزینه </th>
            
                            </tr>
            
                        </thead>
            
                        <tbody>
            
                            <tr class="text-center col-12" *ngFor="let item of list_RouteCost;let i = index">
    
                                <td> {{ i + 1 | faNum }} </td>
    
                                <td class="dirl f22 text-center pointer">
        
                                    <i class="fa fa-edit text-primary mx-1" (click)="editModal_Cost(item,i)" title=" ویرایش"></i>
            
                                    <i class="fa fa-trash text-danger mx-1" (click)="delete_Route_Cost(item)" title=" حذف "></i>
                                    
                                </td>
    
                                <td> {{ item.strMobileType_strComment }} </td>
    
                                <td> {{ item.iCost.toLocaleString() + ' ریال ' | faNum }} </td>
            
                            </tr>
            
                        </tbody>
          
                    </table>
          
                </div>

            </ng-container>

            <ng-container *ngIf="bRouteCost">

                <div [formGroup]="saveRouteCost">

                    <div dir="rtl" class="p-2">

                        <label class="mb-2"> * نوع خودرو </label>
    
                        <select class="form-select bg-light" formControlName="tiMobileType">
    
                            <option value="-1"> انتخاب کنید </option>
    
                            <option *ngFor="let item of list_MobileType" value="{{item.tiMobileType}}">
    
                                {{item.strComment}}
    
                            </option>
    
                        </select>
    
                    </div>
    
                    <div dir="rtl" class="p-2">
    
                        <label class="mb-2"> * هزینه ( ریال ) </label>
    
                        <input type="text" dir="ltr" 
                        
                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                            
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            class="w-100 form-control" formControlName="iCost">
    
                    </div>
    
                    <div class="mt-2 p-2">
    
                        <button class="btn  px-5" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' "
                        
                             (click)="bEditMode ? edit_RouteCost() : add_RouteCost()">
    
                             {{ bEditMode ? 'ویرایش' : 'افزودن' }}
    
                        </button>
    
                    </div>

                </div>

            </ng-container>

        </div>

        <div class="modal-footer"></div>
  
      </div>
  
    </div>
  
</div>
